<script>
    import { setContext } from 'svelte'
    import { writable } from 'svelte/store'
    export let currentTabId = 0
    const currentTab = writable(currentTabId)
    const tabData = writable([])
    const events = writable({})
    let startIndex = -1
    setContext('events', events)
    setContext('currentTab', currentTab)
    setContext('tabData', tabData)
    setContext('setIndex', {
        index: () => {
            startIndex += 1
            return startIndex
        },
    })
    $: currentTabId = $currentTab
    $: if (!$tabData.some((d) => d.id === $currentTab)) {
        $currentTab = $tabData[0]?.id
    }
</script>

<div class="container">
    <div class="head">
        <ul>
            {#each $tabData as { label, alt, icon, id }}
                {@const active = id === $currentTab}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <li
                    class:active
                    on:click={(_) => ($currentTab = id)}
                    on:click={$events[id]['click']}
                    title={alt}
                >
                    {#if icon}
                        <svelte:component
                            this={icon}
                            color={`var(--color${active ? '-brand-primary-01' : '-grey-400'}`}
                            size={32}
                        />
                    {/if}
                    {label}
                </li>
            {/each}
            {#if $$slots.option}
                <div class="option">
                    <slot name="option" />
                </div>
            {/if}
        </ul>
    </div>
    <div class="content">
        <slot />
    </div>
</div>

<style>
    .container {
        display: flex;
        padding: 0;
        flex-direction: column;
        gap: 25px;
    }
    .content {
        position: relative;
        widows: 100%;
        height: fit-content;
        margin: 0;
        padding: 0;
    }
    .head {
        box-shadow:
            0px 2px 4px rgba(0, 0, 0, 0.2),
            0px -1px 1px rgba(0, 0, 0, 0.02);
        background: white;
        border-radius: 8px;
        padding: 0;
        margin: 0;
    }
    .option {
        margin-left: auto;
        width: auto;
        padding-right: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
    ul {
        /* color: grey; */
        display: flex;
        padding: 0;
        margin: 0;
        height: 80px;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        user-select: none;
        clip-path: inset(0% 0% 0% 0% round 8px);
    }
    li {
        list-style: none;
        position: relative;
        display: flex;
        cursor: pointer;
        justify-content: center;
        width: 100%;
        max-width: 307px;
        align-items: center;
        gap: 16px;
        color: var(--color-grey-400);
        /* background: rgba(0, 0, 0, 0.2); */
        height: 100%;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 17px;
        line-height: 22px;
        border-radius: 8px;
    }
    .active {
        color: var(--color-brand-primary-01);
        font-style: normal;
        font-weight: 500;
        transition: color 0.2s ease-in-out;
    }

    .active::after {
        content: '';
        position: absolute;
        width: 98%;
        height: 8px;
        background-color: var(--color-brand-primary-01);
        top: calc(100% - 4px);
        border-radius: 4px;
        animation: fly 0.2s ease-in-out;
    }
    @keyframes fly {
        0% {
            transform: translateY(8px);
        }
        100% {
            transform: translateY(0px);
        }
    }
</style>
